import { Component, OnInit } from '@angular/core';
import { HeaderService } from '../header.service';

@Component({
  moduleId: module.id,
  selector: 'app-header',
  template: `
  <p>
  header works!
</p>
<h1>
  {{header}}
</h1>
  `
})
export class HeaderComponent implements OnInit {
  header: string;

  constructor(private service: HeaderService) { }

  ngOnInit() {
    this.header = this.service.getHeader();
  }

}
